// extracted by mini-css-extract-plugin
export default {"skeleton-bar":"RuleCardSkeleton_skeleton-bar__7BB4A","shimmer":"RuleCardSkeleton_shimmer__MttQS"};